import { render, staticRenderFns } from "./ComWrong.vue?vue&type=template&id=4e87dca2&scoped=true&"
import script from "./ComWrong.vue?vue&type=script&lang=js&"
export * from "./ComWrong.vue?vue&type=script&lang=js&"
import style0 from "./ComWrong.vue?vue&type=style&index=0&id=4e87dca2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e87dca2",
  null
  
)

export default component.exports